import { createQuery } from 'react-query-kit';

import * as Types from '../api/merchant/types.api';
import * as API from '../api/merchant/index.api';

//
//

const key = 'merchant';

//

export const useMerchantByCodeGet = createQuery<Types.MerchantResponse, Types.MerchantByCodeQuery>({
  queryKey: [key, 'by-code'],
  fetcher: (params) => API.getMerchantByCodeAPI(params),
});
